// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1m7NA","title":"ClientInsurance_title__HMMrN","itemText":"ClientInsurance_itemText__2zPN2"};